webpackJsonp([70156927454246],{

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HTMLContent = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTMLContent = exports.HTMLContent = function HTMLContent(_ref) {
		var content = _ref.content,
		    className = _ref.className;
		return _react2.default.createElement('div', { className: className, dangerouslySetInnerHTML: { __html: content } });
	};
	
	var Content = function Content(_ref2) {
		var content = _ref2.content,
		    className = _ref2.className;
		return _react2.default.createElement(
			'div',
			{ className: className },
			content
		);
	};
	
	Content.propTypes = {
		content: _propTypes2.default.string,
		className: _propTypes2.default.string
	};
	Content.defaultProps = {
		content: '',
		className: null
	};
	
	HTMLContent.propTypes = Content.propTypes;
	
	exports.default = Content;

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.staticPageQuery = exports.StaticPageTemplate = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(51);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Page = __webpack_require__(27);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Content = __webpack_require__(69);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StaticPageTemplate = exports.StaticPageTemplate = function StaticPageTemplate(_ref) {
		var title = _ref.title,
		    content = _ref.content,
		    contentComponent = _ref.contentComponent,
		    subtitle = _ref.subtitle,
		    helmet = _ref.helmet,
		    pageBG = _ref.pageBG;
	
		var PageContent = contentComponent || _Content2.default;
	
		return _react2.default.createElement(
			_Page2.default,
			{ title: title, subtitle: subtitle, hero: pageBG.childImageSharp },
			helmet || '',
			_react2.default.createElement(
				'div',
				{ className: 'content' },
				_react2.default.createElement(PageContent, { content: content })
			)
		);
	};
	
	StaticPageTemplate.propTypes = {
		title: _propTypes2.default.string.isRequired,
		content: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
		contentComponent: _propTypes2.default.func,
		subtitle: _propTypes2.default.string.isRequired,
		helmet: _propTypes2.default.objectOf(_propTypes2.default.any),
		pageBG: _propTypes2.default.shape({
			childImageSharp: _propTypes2.default.object
		}).isRequired
	};
	StaticPageTemplate.defaultProps = {
		contentComponent: null,
		helmet: null
	};
	
	var StaticPage = function StaticPage(_ref2) {
		var data = _ref2.data;
		var _data$page = data.page,
		    title = _data$page.frontmatter.title,
		    html = _data$page.html,
		    excerpt = _data$page.excerpt,
		    slug = _data$page.fields.slug,
		    _data$site$siteMetada = data.site.siteMetadata,
		    siteTitle = _data$site$siteMetada.title,
		    shortTitle = _data$site$siteMetada.shortTitle,
		    pageBG = data.pageBG;
	
		var helmet = _react2.default.createElement(
			_reactHelmet2.default,
			null,
			_react2.default.createElement(
				'title',
				null,
				title,
				' | ',
				shortTitle
			),
			_react2.default.createElement('meta', { name: 'description', content: excerpt }),
			_react2.default.createElement('meta', { property: 'og:title', content: title + ' | ' + shortTitle }),
			_react2.default.createElement('meta', { property: 'og:type', content: 'article' }),
			_react2.default.createElement('meta', { property: 'og:url', content: slug }),
			_react2.default.createElement('meta', { property: 'og:description', content: excerpt })
		);
	
		return _react2.default.createElement(StaticPageTemplate, {
			contentComponent: _Content.HTMLContent,
			title: title,
			content: html,
			subtitle: siteTitle,
			helmet: helmet,
			pageBG: pageBG
		});
	};
	
	StaticPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.object,
			site: _propTypes2.default.object,
			pageBG: _propTypes2.default.object
		}).isRequired
	};
	
	exports.default = StaticPage;
	var staticPageQuery = exports.staticPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-static-page-js-3388235b39fac1d866c2.js